// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/" + {63: "alertFroala",909: "document-froala",}[chunkId] + "." + {63: "ad73f727",909: "082aefe1",}[chunkId] + ".chunk.css"
}